(function() {
    'use strict';

    angular
        .module('valueconnectApp')
        .controller('AppraiserUserDeleteController',AppraiserUserDeleteController);

    AppraiserUserDeleteController.$inject = ['$uibModalInstance', 'entity', 'AppraiserUser'];

    function AppraiserUserDeleteController($uibModalInstance, entity, AppraiserUser) {
        var vm = this;

        vm.appraiserUser = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            AppraiserUser.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
